import helper from '../helper';

export default {
	state: {
		repeatCharge: {
			loading: false,
		},
		chargeProject: {
			loading: false,
			data: {},
		},
	},
	mutations: {
		requestRepearCharge(state) {
			state.repeatCharge.loading = true;
		},
		successRepeatCharge(state) {
			state.repeatCharge.loading = false;
		},
		requestChargeProject(state) {
			state.repeatCharge.loading = true;
		},
		successChargeProject(state, data) {
			state.repeatCharge.loading = false;
			state.chargeProject.data = data;
		},
	},
	actions: {
		async setRepeatCharge({ commit }, params) {
			return helper(this, async () => {
				const data = params;
				data.is_cfjf = data.is_cfjf ? 'YES' : 'NO';
				commit('requestRepearCharge');
				await a.api('setCfjfAndKhdJf', data);
				commit('successRepeatCharge');
			});
		},
		async getChargeProject({ commit }, params) {
			return helper(this, async () => {
				commit('requestChargeProject');
				const res = await a.api('sfxmGetById', params);
				res.result.is_cfjf = res.result.is_cfjf === 'YES';
				commit('successChargeProject', res.result);
			});
		},
	},
};
